import { create } from "./logger";
import { getSparkflowChatEndpoint } from "./sparkflow-constants";
const logger = create('sparkflow-api');
export async function postSparkflowChat(params, isMTService, signal) {
    try {
        const response = await fetch(getSparkflowChatEndpoint(isMTService), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
            signal,
        });
        if (!response.ok) {
            logger.error('Sparkflow chat request failed:', response.status, response.statusText);
        }
        return response;
    }
    catch (error) {
        logger.error('Sparkflow chat network error:', error);
        throw error;
    }
}
//# sourceMappingURL=sparkflow-api.js.map